import { useMemo } from "react";
import { useBinFoldersSubscription } from "__gen__/appService";

export const useBinFolders = ({ orgId }: { orgId: string }) => {
  const { data, loading } = useBinFoldersSubscription({ orgId });
  const folders = useMemo(() => (data && data.folders) || [], [data]);

  return { folders, loading };
};
